module.exports = __webpack_public_path__ + "static/media/loc7_img3.d9c45557.jpg";